<app-internal-banner [message]="'This page is for crew only. Clients cannot view this page.'">
</app-internal-banner>
<app-spinner></app-spinner>
<div class="section-container message-detail-section">
  <app-message-detail-action
  ></app-message-detail-action>
  <!-- Notification Banner -->
  <div *ngIf="currentNotification" class="pt-2">
    <c11n-banner
      [variant]="currentNotification.type"
      [hasCloseControl]="true"
      [size]="'small'"
      (closeEvent)="closeNotification()">
      {{ currentNotification.details }}
    </c11n-banner>
  </div>
  <app-message-detail-table
  ></app-message-detail-table>
</div>
